
export const hasPermission = (userPermissions, moduleName, requiredPermission) => {
    // console.log("Checking permissions for:", moduleName, "with required permission:", requiredPermission);
    // console.log("User Permissions Array:", userPermissions);

    return Array.isArray(userPermissions) &&
        userPermissions.some(
            (perm) => perm.module_name === moduleName && perm.permission_name === requiredPermission
        );
};

// utils/permissions.js
export const hasParentModuleAccess = (permissions, parentModuleName) => {
    return permissions.some(item => item.parent_module_name === parentModuleName);
};
  


